// Copyright (c) 2025 by Audere

import React from "react";
import { Box, Typography } from "@mui/material";
import { createStyleSheet } from "../utils/styles";
import { useFormContext, useWatch } from "react-hook-form";

const DebugPanel: React.FC = () => {
  const { control } = useFormContext();
  const values = useWatch({ control });
  const nestedLabels = values;

  return (
    <Box sx={styles.debugBox}>
      <Typography variant="h6">Debug Panel</Typography>
      <Typography variant="subtitle2">Current form state:</Typography>
      <pre style={{ fontSize: "10px", whiteSpace: "pre-wrap" }}>
        {JSON.stringify(nestedLabels, null, 2)}
      </pre>
    </Box>
  );
};

const styles = createStyleSheet({
  debugBox: {
    backgroundColor: "#f5f5f5",
    border: "1px solid lightgrey",
    marginTop: 2,
    padding: 2,
    borderRadius: 2,
  },
});

export default DebugPanel;
